var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"d-flex align-items-center justify-content-center",attrs:{"variant":"primary"},on:{"click":_vm.refreshTable}},[_c('feather-icon',{attrs:{"icon":"RefreshCwIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }